import { Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";

import "regenerator-runtime/runtime";

import ManagerBase from "./ManagerBase";
import Organization from "../models/Organization";
import OrganizationMembership from "../models/OrganizationMembership";

class OrganizationMembershipManager extends ManagerBase {
	constructor () {
		super("organizationMembershipManager");

		this.responsesModelClass = OrganizationMembership;
		this.remoteClassName = "organization-member";
	}

	async accept (guid) {
		const rd = NousCore.api.createRequest({ item: { guid } });

		const result = await this.sendRequest(rd, "accept");
		result.items = result.data.items; // Temporaneo
		return result;
	}

	async checkUserRegistration (guid) {
		const rd = NousCore.api.createRequest({ item: { guid } });

		const result = await this.sendRequest(rd, "check-user-registration");
		result.items = result.data.items; // Temporaneo
		return result;
	}

	async getByGuidList (guidList) {
		const rd = NousCore.api.createRequest({ item: { guidList } });

		const result = await this.sendRequest(rd, "get-by-guid-list");
		result.items = result.data.items; // Temporaneo
		return result;
	}

	async getByOwnerGuid (ownerGuid) {
		const rd = NousCore.api.createRequest({ item: { ownerGuid } });
		const requestedAction = "get-by-owner-guid";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						let organization;

						if (data.items.length > 0) {
							organization = new Organization(data.items[0]);
						}

						return {
							data: organization,
							requestedAction,
							status: "ok"
						};
					}
				}
			}
		});
	}

	async getList () {
		const organizationMembershipListResult = await super.getList();

		Shark.set({
			organizationMembershipList: organizationMembershipListResult.data,
		});
		
		return organizationMembershipListResult;
	}

	async getListByOrganizationGuid (organizationGuid) {
		const rd = NousCore.api.createRequest({ item: { organizationGuid } });
		const requestedAction = "get-list-by-oganization-guid";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const organizationMembershipList = Shark.getInstanceList(this.responsesModelClass, data.items);

						organizationMembershipList.sort((a, b) => {
							if (a.role === OrganizationMembership.ROLE_OWNER && b.role !== OrganizationMembership.ROLE_OWNER) {
								return -1;
							}
							else if (a.role === OrganizationMembership.ROLE_POWER_ADMIN && b.role !== OrganizationMembership.ROLE_POWER_ADMIN) {
								return -1;
							}
							else if (a.role !== OrganizationMembership.ROLE_POWER_ADMIN && b.role === OrganizationMembership.ROLE_POWER_ADMIN) {
								return 1;
							}
							else if (a.role === OrganizationMembership.ROLE_ADMIN && b.role !== OrganizationMembership.ROLE_ADMIN) {
								return -1;
							}
							else if (a.role !== OrganizationMembership.ROLE_ADMIN && b.role === OrganizationMembership.ROLE_ADMIN) {
								return 1;
							}
							else if (a.role === OrganizationMembership.ROLE_POWER_USER && b.role !== OrganizationMembership.ROLE_POWER_USER) {
								return -1;
							}
							else if (a.role !== OrganizationMembership.ROLE_POWER_USER && b.role === OrganizationMembership.ROLE_POWER_USER) {
								return 1;
							}
							else if (a.role === OrganizationMembership.ROLE_USER && b.role !== OrganizationMembership.ROLE_USER) {
								return -1;
							}
							else if (a.inviteEMail < b.inviteEMail) {
								return -1;
							}
							else if (a.inviteEMail > b.inviteEMail) {
								return 1;
							}
						});

						Utils.reindexList(organizationMembershipList);

						return {
							data: organizationMembershipList,
							requestedAction,
							status: "ok"
						};
					}
				}
			}
		});
	}

	async getListByOrganizationGuidList (organizationGuidList) {
		const rd = NousCore.api.createRequest({ item: { guidList: organizationGuidList } });
		const requestedAction = "get-list-by-oganization-guid-list";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1: {
						const allUserMembershipList = Shark.getInstanceList(this.responsesModelClass, data.items);

						Utils.reindexList(allUserMembershipList);

						Shark.set({
							allUserMembershipList,
						});

						return {
							data: allUserMembershipList,
							requestedAction,
							status: "ok"
						};
					}
				}
			}
		});
	}

	async save (organizationMembership) {
		const rd = NousCore.api.createRequest({ item: organizationMembership.export() });
		const requestedAction = organizationMembership.guid === "" ? "insert" : "update";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						if (data.items.length > 0) {
							organizationMembership.import(data.items[0]);
							organizationMembership.clean();
						}
						return {
							data: organizationMembership,
							requestedAction,
							status: "ok"
						};
				}
			}
		});
	}
}

const organizationMembershipManager = new OrganizationMembershipManager();

Shark.registerController(organizationMembershipManager);

export default organizationMembershipManager;